(function(angular){
	'use strict';
	
	angular
		.module('localRealEstateModule')
		.directive('howManagedPortfoliosWork', [
			'$window',
			howManagedPortfoliosWorkFunction
		]);
	
	function howManagedPortfoliosWorkFunction($window){
		return {
			restrict: 'A',
			scope: true,
			link: function(scope, elem, attr) {

				scope.changeStep = function(stepNumber) {
					scope.currentStep = stepNumber;

					var videoElem = elem.find('video')[stepNumber];
					videoElem.play();

					if($window.mixpanel) {
						$window.mixpanel.track("How Managed Portfolios Work Step Selected", {
							"Step" : stepNumber
						});
					}
				};

				scope.changeStep(0);
			}
		};
	}
})(window.angular);